import { render } from "./coreFeatures.vue?vue&type=template&id=2902fe3c&scoped=true"
import script from "./coreFeatures.vue?vue&type=script&lang=js"
export * from "./coreFeatures.vue?vue&type=script&lang=js"

import "./coreFeatures.vue?vue&type=style&index=0&id=2902fe3c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2902fe3c"]])

export default __exports__